/**
 * 菜单配置文件
 * 新增页面时，只需在这里添加配置即可自动生成菜单
 */

// 菜单图标映射
export const menuIcons = {
  dashboard: 'el-icon-s-home',
  configs: 'el-icon-s-tools',
  users: 'el-icon-user',
  settings: 'el-icon-setting',
  logs: 'el-icon-document',
  analytics: 'el-icon-data-line',
  security: 'el-icon-lock',
  system: 'el-icon-cpu',
  database: 'el-icon-coin',
  api: 'el-icon-connection',
  cache: 'el-icon-refresh',
  email: 'el-icon-message',
  notification: 'el-icon-bell',
  file: 'el-icon-folder',
  backup: 'el-icon-download',
  monitor: 'el-icon-view',
  report: 'el-icon-s-data',
  help: 'el-icon-question',
  about: 'el-icon-info'
}

// 管理员菜单配置
export const adminMenuConfig = [
  {
    index: 'admin/dashboard',
    title: '仪表盘',
    icon: menuIcons.dashboard,
    path: '/admin/dashboard',
    isDefault: true, // 标记为默认页面
    order: 1 // 排序权重
  },
  {
    index: 'admin/users',
    title: '用户管理',
    icon: menuIcons.users,
    path: '/admin/users',
    order: 2
  },
  {
    index: 'admin/configs',
    title: '配置管理',
    icon: menuIcons.configs,
    path: '/admin/configs',
    order: 3
  },
  {
    index: 'admin/logs',
    title: '日志管理',
    icon: menuIcons.logs,
    path: '/admin/logs',
    order: 4
  }
  // 新增页面时，只需在这里添加新的配置项即可
  // 示例：
  // {
  //   index: 'admin/users',
  //   title: '用户管理',
  //   icon: menuIcons.users,
  //   path: '/admin/users',
  //   order: 3
  // },
  // {
  //   index: 'admin/logs',
  //   title: '系统日志',
  //   icon: menuIcons.logs,
  //   path: '/admin/logs',
  //   order: 4
  // }
]

// 用户菜单配置（如果需要的话）
export const userMenuConfig = [
  {
    index: 'dashboard',
    title: '首页面板',
    icon: menuIcons.dashboard,
    path: '/',
    isDefault: true,
    order: 1
  }
]

/**
 * 根据用户类型获取菜单配置
 * @param {string} userType - 用户类型 ('admin' | 'user')
 * @returns {Array} 菜单配置数组
 */
export function getMenuConfig(userType = 'admin') {
  const config = userType === 'admin' ? adminMenuConfig : userMenuConfig;
  // 按 order 字段排序
  return config.sort((a, b) => (a.order || 999) - (b.order || 999));
}

/**
 * 根据路由路径自动生成菜单配置
 * 这个方法可以从路由配置中自动提取菜单信息
 * @param {Array} routes - 路由配置数组
 * @param {string} parentPath - 父路由路径，默认为 '/admin'
 * @returns {Array} 菜单配置数组
 */
export function generateMenuFromRoutes(routes, parentPath = '/admin') {
  const menuItems = [];
  
  routes.forEach(route => {
    if (route.meta && route.meta.menu) {
      // 跳过空路径的重定向路由
      if (!route.path || route.path === '') {
        return;
      }
      
      // 构建完整的路径
      const fullPath = `${parentPath}/${route.path}`;
      // 构建菜单索引
      const menuIndex = `admin/${route.path}`;
      
      menuItems.push({
        index: menuIndex,
        title: route.meta.menu.title,
        icon: route.meta.menu.icon || menuIcons.dashboard,
        path: fullPath,
        isDefault: route.meta.menu.isDefault || false,
        order: route.meta.menu.order || 999
      });
    }
  });
  
  return menuItems.sort((a, b) => (a.order || 999) - (b.order || 999));
}
